import { useState } from "react";
import { Link } from 'react-router-dom';
import { Banner, FooterForm, Hotel, InfoSection, Location } from "../components";
import { tracking } from '../utils/tracking';
import { imgs } from '../assets/imgs';
import { useResizeImg } from '../hooks/useResizeImg';


export const Venue = () => {
   document.title = "New England Venture Summit | Venue";

   const [isLoading, setIsLoading] = useState(true);
   const imageSource = useResizeImg(imgs.venue.venueBannerDesktop, imgs.venue.venueBannerMobile)

   return (
      <div className='venue'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h3 >Join us at</h3>
               <h1 >Hilton | Boston Dedham, MA</h1>
            </section>
            <section>
               <Link to='/registration' onClick={() => tracking(293)} className="btn">GET YOUR TICKET</Link>
            </section>
         </Banner>
         {/* <InfoSection  img={imgs.venue.venueInfo}>
            <h1>This September, the New York Venture Summit returns with a bang!</h1>
            <span></span>
            <p>Take your place among the tech industry’s best and brightest for 2 days of ground-breaking content including panels and presentations that will showcase the most cutting-edge innovations in the world.  Experience a highly-filtered look at the technology destined to change future.</p>
            <p>Examine ideas with the industry’s leading visionaries and decision-makers in a relaxed and friendly atmosphere assured to engage, enlighten, and excite. With a renewed market momentum, and with innovation exploding, the New York Venture Summit is the premier event to make connections, get noticed, and get a first look at the technologies shaping our future.</p>
            <div className='btn-container'>
            <Link className='btn b2' to='/registration' onClick={() => tracking(294)} >Tickets</Link>
            </div>
         </InfoSection> */}
         <Location />
         <Hotel/>
         <FooterForm />
      </div>
   );
};
